

const VoyageReducer = (state, action) => {
    switch (action.type) {
        case "GET_VOYAGES_START":
            return {
                ...state,
                voyages: [],
                isFetching: true,
                error: false,
            };
        case "GET_VOYAGES_SUCCESS":
            return {
                ...state,
                voyages: action.payload.voyages,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_VOYAGES_FAILURE":
            return {
                ...state,
                voyages: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_VOYAGE_START":
            return {
                ...state,
                voyage: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_VOYAGE_SUCCESS":
            return {
                ...state,
                voyage: action.payload.voyage,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_VOYAGE_FAILURE":
            return {
                ...state,
                voyage: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_VOYAGE_START":
            return {
                ...state,
                voyageUpdate: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_VOYAGE_SUCCESS":
            return {
                ...state,
                voyageUpdate: action.payload.voyage,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_VOYAGE_FAILURE":
            return {
                ...state,
                voyageUpdate: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
       default:
            return { ...state };
    }
}

export default VoyageReducer;